import { Box, Chip, IconButton } from "@material-ui/core";
import { Delete as DeleteIcon, Edit as EditIcon } from "@material-ui/icons";
import React from "react";
import { Table } from "../../../../../components";
import {
  Access as SystemAccess,
  System,
  useRequestContext,
} from "../../../../../context";
import { AdditionalFormModal, Values } from "../additional-form-modal";
import { useClassnames } from "./classnames";
import { init, reducer } from "./state";

type Props = {
  access: SystemAccess;
  host: string;
  name: string;
  system: System;
  onSystemSelected: (system: System, access: SystemAccess) => void;
};

export const Access: React.FC<Props> = ({
  access,
  system,
  onSystemSelected,
}) => {
  const classnames = useClassnames();
  const [localState, localDispatch] = React.useReducer(reducer, {}, init);
  const [requestContextState, requestContextDispatch] = useRequestContext();
  const form = React.useMemo(() => {
    const { additionalForm, manual, revokeNeededForm } = system.application;
    const type = requestContextState.values.type;

    return (
      !!additionalForm && !manual && (type !== "revoke" || revokeNeededForm)
    );
  }, [requestContextState.values.type, system.application]);

  function handleAdditionalFormChipClick(): void {
    localDispatch({
      type: "open-additional-form-modal",
    });
  }

  function handleDeleteAccessButtonClick(): void {
    requestContextDispatch({
      type: "remove-system-access",
      system,
      access,
    });
  }

  function handleAdditionalFormCancel(): void {
    localDispatch({
      type: "close-additional-form-modal",
    });
  }

  function handleAdditionalFormSubmit(values: Values): void {
    requestContextDispatch({
      type: "update-system-access",
      system,
      access,
      data: {
        form: values,
      },
    });
    localDispatch({
      type: "close-additional-form-modal",
    });
  }

  return (
    <Table.Row>
      <Table.Cell>
        <Box textOverflow="ellipsis">{system.application.name}</Box>
      </Table.Cell>
      <Table.Cell>{system.application.host}</Table.Cell>
      <Table.Cell>
        {system.application.lz ? "N/A" : access.environment?.name}
      </Table.Cell>
      <Table.Cell>{access.role?.name}</Table.Cell>
      <Table.Cell>
        {form ? (
          <React.Fragment>
            <Chip
              className={classnames[access.form ? "complete" : "incomplete"]}
              component={Box}
              label={access.form ? "Complete" : "Incomplete"}
              onClick={handleAdditionalFormChipClick}
              size="small"
              width="100%"
            />
            <AdditionalFormModal
              application={system.application}
              onCancel={handleAdditionalFormCancel}
              onSubmit={handleAdditionalFormSubmit}
              open={localState.additional_form_modal.open}
              values={access.form}
            />
          </React.Fragment>
        ) : (
          <Chip
            component={Box}
            disabled
            label="Not Required"
            size="small"
            variant="outlined"
            width="100%"
          />
        )}
      </Table.Cell>
      <Table.Cell>
        <IconButton
          size="small"
          onClick={() => onSystemSelected(system, access)}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      </Table.Cell>
      <Table.Cell>
        <IconButton size="small" onClick={handleDeleteAccessButtonClick}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Table.Cell>
    </Table.Row>
  );
};
